/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smug_Loved_Tern_CoaxInputs */

const fr_smug_loved_tern_coax = /** @type {(inputs: Smug_Loved_Tern_CoaxInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programmes Perso`)
};

/**

* @param {Smug_Loved_Tern_CoaxInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const smug_loved_tern_coax = /** @type {((inputs?: Smug_Loved_Tern_CoaxInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smug_Loved_Tern_CoaxInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_smug_loved_tern_coax(inputs)
});